export const NO_KEY_ERROR = 'NoKeyError';
export const DECRYPTION_ERROR = 'DecryptionError';
